import { THUMB_DOWN_PERCENT, THUMB_MIDDLE_PERCENT, THUMB_UP_PERCENT } from 'common/RatingUtilities';
import { RatingPercent } from './constants';

export const isValidRatingPercentValue = (ratingPercent: unknown): ratingPercent is RatingPercent =>
  ratingPercent === THUMB_UP_PERCENT ||
  ratingPercent === THUMB_MIDDLE_PERCENT ||
  ratingPercent === THUMB_DOWN_PERCENT ||
  ratingPercent === null;
